/**
 * v-stable-width 指令
 *
 * 根据模板字符串中数字的最大可能宽度，为元素设置 min-width，
 * 防止倒计时等动态数字内容导致容器宽度跳动。
 *
 * 用法：
 *   <span v-stable-width="'00:00:00'">{{ countdown }}</span>
 *   <span v-stable-width="'0天00:00'">{{ countdown }}</span>
 *
 * 原理：测量 0-9 在当前字体下的宽度，找到最宽数字，
 * 将模板中所有数字替换为最宽数字后测量整体宽度，设为 min-width。
 */

function measureMaxWidth(el, template) {
  const style = window.getComputedStyle(el)
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  ctx.font = `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`

  // 找出 0-9 中最宽的数字
  let maxDigit = '0'
  let maxDigitWidth = 0
  for (let i = 0; i <= 9; i++) {
    const w = ctx.measureText(String(i)).width
    if (w > maxDigitWidth) {
      maxDigitWidth = w
      maxDigit = String(i)
    }
  }

  // 将模板中所有数字替换为最宽数字，测量整体宽度
  const maxStr = template.replace(/\d/g, maxDigit)
  return Math.ceil(ctx.measureText(maxStr).width)
}

function apply(el, template) {
  if (!template) return
  // 等一帧确保字体已加载渲染
  requestAnimationFrame(() => {
    const width = measureMaxWidth(el, template)
    el.style.minWidth = width + 'px'
  })
}

const stableWidth = {
  bind(el, binding) {
    apply(el, binding.value)
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      apply(el, binding.value)
    }
  },
  unbind(el) {
    el.style.minWidth = ''
  },
}

export default stableWidth
